import React from 'react';

import ScreverInActionSec from 'sections/common/ScreverInAction';

const ScreverInAction = ({ data }) => {
  return <ScreverInActionSec data={data} />;
};

export default ScreverInAction;
